<template>
  <z-card>
    <form @submit.prevent="searchStudent()" class="search-student">
      <z-input-field
        label="Informe o CPF do aluno para visualizar os boletos"
        class="search-student__input"
        :has-error="searchStudentForm.fields.cpf.hasError"
        :error-message="searchStudentForm.fields.cpf.error"
      >
        <z-input
          placeholder="Ex.: 987.654.321-90"
          v-mask="'###.###.###-##'"
          alt="CPF do aluno"
          :has-error="searchStudentForm.fields.cpf.hasError"
          v-model="searchStudentForm.fields.cpf.value"
        />
      </z-input-field>
      <z-button
        size="medium"
        variant="primary"
        type="submit"
        :class="{ 'search-student__button--error': searchStudentForm.fields.cpf.error }"
        :is-loading="searchingStudent"
      >
        Procurar
      </z-button>
    </form>
  </z-card>
</template>

<script>
import { FormGroup } from 'utils/form';
import InstitutionPanelService from 'services/InstitutionPanelService';

export default {
  props: {
    encryptedInstitutionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchingStudent: false,
      searchStudentForm: new FormGroup({
        cpf: { required: true, cpf: true, valid: true },
      }),
    };
  },
  methods: {
    searchStudent() {
      if (this.searchStudentForm.validateForm()) {
        this.searchingStudent = true;

        InstitutionPanelService
          .loadStudentBillings(this.encryptedInstitutionId, this.searchStudentForm.getValue('cpf'))
          .then((data) => {
            this.$router.push({
              name: 'student-details',
              params: { cpfHash: data.student.cpf_hash, studentBillings: data },
            });
          })
          .catch(() => {
            this.$toast.show('danger', 'CPF não encontrado', 4000);
          })
          .finally(() => {
            this.searchingStudent = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-student {
  align-items: flex-end;
  display: flex;
  flex-direction: row;

  @media screen and (max-width: $screen-md-max) {
    flex-direction: column;
  }
}

.search-student__button--error {
  align-self: center;
  margin-top: var(--space-small);

  @media screen and (max-width: $screen-md-max) {
    align-self: flex-end;
    margin-top: 0;
  }
}

.search-student__input {
  margin-bottom: 0;
  margin-right: var(--space-medium);
  flex: 1;
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    align-self: flex-start;
    margin-bottom: var(--space-medium);
  }
}
</style>
